
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brokenapes",
      function () {
        return require("private-next-pages/brokenapes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brokenapes"])
      });
    }
  